/* eslint-disable react/prop-types */
/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconStatus, StatusIconSize} from '../types/types';

interface Props {
  size?: StatusIconSize;
  type: IconStatus;
  style?: any;
}
/**
 * @StatusIcon
 *
 * Defines the Design Language System (DLS) Status Active, Idle, Issue, Parked and Offline
 * Icon components.
 *
 * ```typescript
 *    import {IconStatus} from '@ion/dls/src/types/types';
 *
 *    <StatusIcon type={IconStatus.active} size={StatusIconSize.small} />
 *    <StatusIcon type={IconStatus.idle} size={StatusIconSize.basic} />
 *    <StatusIcon type={IconStatus.issue} />
 *    <StatusIcon type={IconStatus.parked} />
 *    <StatusIcon type={IconStatus.offline} />
 *
 * ```
 *
 *   !NOTE: This Icon defines non-standard sizes within the DLS.
 *   @see https://www.figma.com/file/gtF4hB3eC4fvzKVJ2DNDtu/00_DLS_Foundation?node-id=1%3A172
 */
export const StatusIcon = ({size = StatusIconSize.basic, type, style}: Props) => (
  <svg width={24} height={size} viewBox='0 0 10 10' fill='none' style={style}>
    <circle cx={5} cy={5} r={5} fill={(type as unknown) as string} />
  </svg>
);
